import React, { FunctionComponent } from 'react';

const ProcessError: FunctionComponent = () => (
  <div
    className="error-text-wrapper text-black"
    data-testid="process-error-screen-container"
  >
    {/* Below content is intentionally not part of control center API
    as this page is displayed incase control center APIs are down.
    Hence keep the below content hardcoded. */}
    <p className="error-text">Please Try Again Later</p>
    <p className="fatal-error-text">
      We are sorry, We seem to be having trouble connecting.
    </p>
  </div>
);

export default ProcessError;
